import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import img4 from "../../assets/images/companies/img-4.png";
import img5 from "../../assets/images/companies/img-5.png";
import img8 from "../../assets/images/companies/img-8.png";
import img9 from "../../assets/images/companies/img-9.png";

const jobProcess = [
  {
    id: 1,
    clss: "shadow-lg",
    lable: "Requirement Gathering",
    desc: "Understand client needs and gather system requirements.",
  },
  {
    id: 2,
    lable: "System Design",
    desc: "Design the ERP modules and database schema.",
  },
  {
    id: 3,
    lable: "Development",
    desc: "Develop the application using .NET (C#), React, and SQL Server.",
  },
  {
    id: 4,
    lable: "Implementation & Support",
    desc: "Deploy the system and provide ongoing support.",
  },
];

const categories = [
  {
    id: 1,
    icon: "ri-database-2-line fs-1",
    lable: "Development",
    jobs: "132 Jobs",
    requirement: [
      ["HTML", "CSS", "JavaScript", "React.js"],
      [".Net", "MS-SQL", "Postgres", "Azure"],
    ],
  },
  {
    id: 2,
    icon: "ri-bar-chart-box-line fs-1",
    lable: "Sales",
    jobs: "200 Jobs",
    requirement: [
      ["CRM Tools", "Sales Strategies"],
      ["Communication Skills", "Negotiation"],
    ],
  },
  {
    id: 3,
    icon: "ri-stack-line fs-1",
    lable: "Implementation",
    jobs: "180 Jobs",
    requirement: [
      [".Net", "MS-SQL", "Postgres", "Azure"],
      ["Project Management"],
    ],
  },
  {
    id: 4,
    icon: "ri-headphone-line fs-1",
    lable: "Support",
    jobs: "75 Jobs",
    requirement: [
      ["Customer Support", "Troubleshooting"],
      ["Product Knowledge", "Patience"],
    ],
  },
  {
    id: 5,
    icon: "ri-settings-2-line fs-1",
    lable: "Admin",
    jobs: "110 Jobs",
    requirement: [
      ["MS Office", "Time Management"],
      ["Organization Skills", "Data Analysis"],
    ],
  },
];

const findJob = [
  {
    id: 1,
    company: img3,
    lable: "Full Stack Developer",
    jobs: 3,
    bookmark: false,
    s1: ["C#", "success"],
    s2: ["React", "primary"],
    s3: ["SQL Server", "info"],
  },
  {
    id: 2,
    company: img2,
    lable: "Backend Developer",
    jobs: 2,
    bookmark: true,
    s1: [".NET Core", "success"],
    s2: ["API Development", "warning"],
    s3: ["Database Design", "primary"],
  },
  {
    id: 3,
    company: img4,
    lable: "Database Administrator",
    jobs: 4,
    bookmark: true,
    s1: ["SQL Server", "primary"],
    s2: ["Optimization", "info"],
    s3: ["Backup & Recovery", "danger"],
  },
  {
    id: 4,
    company: img9,
    lable: "HR Specialist",
    jobs: 5,
    bookmark: false,
    s1: ["HR Modules", "success"],
    s2: ["Recruitment", "primary"],
    s3: ["Payroll Systems", "warning"],
  },
  {
    id: 5,
    company: img8,
    lable: "Frontend Developer",
    jobs: 5,
    bookmark: false,
    s1: ["React", "primary"],
    s2: ["UI/UX", "info"],
    s3: ["JavaScript", "warning"],
  },
  {
    id: 6,
    company: img5,
    lable: "Cloud Integration Specialist",
    jobs: 2,
    bookmark: true,
    s1: ["Azure", "info"],
    s2: ["Integration", "primary"],
    s3: ["Scalability", "success"],
  },
  {
    id: 7,
    company: img9,
    lable: "Support Engineer",
    jobs: 6,
    bookmark: true,
    s1: ["Technical Support", "success"],
    s2: ["Bug Fixing", "danger"],
    
  },
  {
    id: 8,
    company: img1,
    lable: "Project Manager",
    jobs: 2,
    bookmark: false,
    s1: ["Agile", "danger"],
    s2: ["Scrum", "success"],
    s3: ["ERP Deployment", "primary"],
  },
];

export { jobProcess, categories, findJob };
